(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-flex-pdp"] && !window.DesignMode) return;
  try {
    
  // Example 1: Modify form data before submission
  document.addEventListener('product-form:submit:before', (event) => {
    event.detail.form.append('source', 'flex-pdp-section');
  });

  // Example 2: Handle successful submission
  document.addEventListener('product-form:submit:success', (event) => {
    const { cart } = event.detail;
    console.log('Added to cart! Total items:', cart.item_count);
    
    // Update cart count display
    const cartCount = document.querySelector('[data-cart-count]');
    if (cartCount) cartCount.textContent = cart.item_count;
  });

  // Example 3: Handle submission errors
  document.addEventListener('product-form:submit:error', (event) => {
    const { error } = event.detail;
    console.error('Add to cart failed:', error.description || error.message);
  });

  // Example 4: Handle cart updates
  document.addEventListener('product-form:cart:update', (event) => {
    const { cart } = event.detail;
    
    // Update cart drawer if available
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer?.renderContents) {
      cartDrawer.renderContents(event.detail.response);
    }
  });

  // Example 5: Prevent cart navigation and show and alert instead
  document.addEventListener('product-form:cart:navigate', (event) => {
    event.preventDefault(); // Prevent default navigation
    alert('Item added to cart');
  });

  // Example 6: Handle cart request externally (e.g., custom cart logic)
  document.addEventListener('product-form:cart:request', async (event) => {
    event.preventDefault(); // Cancel default cart request
    
    try {
      // Custom cart logic here - could be a different endpoint, custom validation, etc.
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: event.detail.form,
        headers: event.detail.config.headers
      });
      
      if (!response.ok) {
        throw new Error('Cart request failed');
      }
      
      const responseData = await response.json();
      
      // Success - call resolve with response data
      event.detail.resolve(responseData);
    } catch (error) {
      // Error - call reject with error
      event.detail.reject(error);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
